module.exports = __webpack_public_path__ + "static/img/boxImg2.184f241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boxImg2.png
// module id = GI6T
// module chunks = 2